import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { LiveEventViewModel } from 'src/app/_models/generatedModels';
import { SelectedDevice } from 'src/app/_models/models';
import { EventService, LiveEventService } from 'src/app/_services/generatedServices';
import { OpentokService } from 'src/app/_services/opentok.service';
import { ToasterService } from 'src/app/_services/toaster.service';
import { CameraTestModalComponent } from '../camera-test/camera-test-modal.component';
declare var zE: any;
const initLayoutContainer = require('opentok-layout-js');

@Component({
  selector: 'bxl-live-event-room-view',
  templateUrl: 'live-event-room-view.component.html',
})
export class LiveEventRoomViewComponent implements OnInit {
  initialized = false;
  session: OT.Session;
  public eventIdOrSlug: any;
  event: LiveEventViewModel;
  public isFullScreen: boolean;
  public selectedScreenDevice: SelectedDevice;
  @ViewChild('fullscreenContainer') fullscreenContainer: ElementRef;
  @ViewChild('webRTCLayoutContainer') webRTCLayoutContainer: ElementRef;
  layout: any;
  openTokInitialized: boolean;
  streamCount: number;
  screenPublisher: OT.Publisher;

  constructor(private route: ActivatedRoute, private router: Router, private modalService: NgbModal, private eventData: EventService, private renderer: Renderer2, private ref: ChangeDetectorRef, private opentokService: OpentokService, private liveEventService: LiveEventService, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.eventIdOrSlug = params.get('id');

      this.eventData.getLiveEvent(this.eventIdOrSlug).subscribe((event) => {
        this.event = event;

        this.initialized = true;
        this.InitOpenTok();
        this.loadZendesk();
      });
    });
  }

  shareSlides() {
    const OT = this.opentokService.getOT();
    const el = this.renderer.createElement('div');

    if (this.selectedScreenDevice) {
      this.screenPublisher = OT.initPublisher(el, { mirror: false, publishAudio: false, fitMode: 'contain', publishVideo: true, resolution: '1280x720', name: 'COMPUTER', width: '100%', insertDefaultUI: true, style: { nameDisplayMode: 'off', archiveStatusDisplayMode: 'auto', buttonDisplayMode: 'off' }, audioSource: this.selectedScreenDevice.audioDeviceId, videoSource: this.selectedScreenDevice.videoDeviceId });
    } else {
      this.screenPublisher = OT.initPublisher(el, { mirror: false, publishAudio: false, fitMode: 'contain', publishVideo: true, resolution: '1280x720', name: 'COMPUTER', width: '100%', insertDefaultUI: true, style: { nameDisplayMode: 'off', archiveStatusDisplayMode: 'auto', buttonDisplayMode: 'off' } });
    }
    el.classList.add('OT_big');
    this.renderer.appendChild(this.webRTCLayoutContainer.nativeElement, el);

    this.layout();
  }

  stopSharing(){
    this.screenPublisher.destroy();
    this.screenPublisher = null;
    this.layout();
  }

  showDeviceSettings() {
    const modalRef = this.modalService.open(CameraTestModalComponent, { size: 'lg', backdrop: 'static', ariaLabelledBy: 'modal-basic-title' });
    if (this.selectedScreenDevice) {
      console.log(this.selectedScreenDevice);
      modalRef.componentInstance.selectedDevice = this.selectedScreenDevice;
    }
    modalRef.result.then(
      (result) => {
        this.selectedScreenDevice = result;

        if (this.screenPublisher) {
          this.screenPublisher.setAudioSource(this.selectedScreenDevice.audioDeviceId);
          this.screenPublisher.setVideoSource(this.selectedScreenDevice.videoDeviceId);
        }
      },
      (reason) => {}
    );
    return;
  }

  loadZendesk() {
    zE('webWidget', 'hide');
    zE('webWidget:on', 'close', () => {
      zE('webWidget', 'hide');
    });

    zE('webWidget:on', 'chat:unreadMessages', () => {
      zE('webWidget', 'show');
      zE('webWidget', 'open');
    });
  }

  InitOpenTok() {
    this.ref.detectChanges();
    this.layout = initLayoutContainer(this.webRTCLayoutContainer.nativeElement).layout;
    let layout = this.layout;

    if (this.openTokInitialized) {
      return;
    }

    console.log('initializing opentok');
    this.opentokService
      .initSessionForEvents(this.event.id)
      .then((session: OT.Session) => {
        this.session = session;

        this.session.on('streamPropertyChanged', (event) => {
          console.log('changed');
          console.log(event.stream.streamId);
        });

        this.session.on('streamCreated', (event) => {
          if (event.stream.name === 'ATEM') {
            return;
          }

          console.log(event.stream.name);
          console.log(event.stream.connection.data);
          this.streamCount++;

          var style: any = { nameDisplayMode: 'off' };

          if (event.stream.name.includes('ATTENDEE:')) {
            style = { nameDisplayMode: 'on' };
            event.stream.name = event.stream.name.replace('ATTENDEE:', '');
          }

          let subscription = this.session.subscribe(event.stream, 'webRTCLayoutContainer', {
            insertMode: 'append',
            style: style,
          });

          if (subscription.stream.videoType === 'screen') {
            subscription.element.classList.add('OT_screen');
            subscription.element.classList.add('OT_big');
          }

          if (subscription.stream.name === 'video-sm') {
            subscription.element.classList.add('OT_big');
            subscription.element.classList.add('OT_video');
          }

          if (subscription.stream.name === 'video') {
            subscription.element.classList.add('OT_ignore');
          }

          subscription.element.addEventListener('dblclick', function () {
            if (subscription.element.classList.contains('OT_big')) {
              subscription.element.classList.remove('OT_big');
            } else {
              subscription.element.classList.add('OT_big');
            }
            layout();
          });
          layout();
          this.ref.detectChanges();

          layout();
        });

        this.session.on('streamDestroyed', (event) => {
          this.streamCount--;
          session.getSubscribersForStream(event.stream).forEach((subscriber) => {
            subscriber.element.classList.remove('ot-layout');

            setTimeout(() => {
              layout();
            }, 200);
          });
          layout();
          this.ref.detectChanges();

          layout();
        });
      })
      .then(() => {
        this.opentokService.connect();
        this.openTokInitialized = true;
      })
      .catch((err) => {
        console.error(err);
        alert('Unable to connect.');
      });
  }

  exitPage() {
    this.router.navigate(['/super-user/events']);
    return;
  }

  fullscreen() {
    let elem = this.fullscreenContainer.nativeElement;
    let doc = <any>document;
    if (!this.isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen();
      }

      elem.classList.add('fullscreen');
      of(null)
        .pipe(delay(500))
        .subscribe((result) => {
          this.isFullScreen = true;
          if (this.layout) {
            this.layout();
          }
        });
    } else {
      if (document.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.mozCancelFullScreen) {
        /* Firefox */
        doc.mozCancelFullScreen();
      } else if (doc.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        /* IE/Edge */
        doc.msExitFullscreen();
      }
      console.log('exit fullscreen');
      elem.classList.remove('fullscreen');
      of(null)
        .pipe(delay(500))
        .subscribe((result) => {
          this.isFullScreen = false;
          if (this.layout) {
            this.layout();
          }
        });
    }
  }

  @HostListener('window:resize', ['$event'])
  chatResized(event) {
    if (this.layout) {
      this.layout();
    }
  }

  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  exit(ev) {
    if (this.isFullScreen) {
      of(null)
        .pipe(delay(1000))
        .subscribe((result) => {
          let elem = this.fullscreenContainer.nativeElement;
          this.isFullScreen = false;
          console.log('exiting');
          elem.classList.remove('fullscreen');
          if (this.layout) {
            this.layout();
          }
        });
    }
  }
}
